import { render, staticRenderFns } from "./CartaoPedidoValores.vue?vue&type=template&id=0e9ae459&scoped=true"
import script from "./CartaoPedidoValores.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoPedidoValores.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoPedidoValores.vue?vue&type=style&index=0&id=0e9ae459&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9ae459",
  null
  
)

export default component.exports